import { graphql, Link } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import { Container } from "../components/layout/Container"
import { Hero } from "../components/layout/Hero"
import Block from "../components/blocks"
import Seo from "../components/Seo"
import striptags from "striptags"
import { dateFromWp, truncate } from "../utils"
import { BreadCrumb } from "../components/BreadCrumb"
import { Label } from "../components/layout/Container"
import { Pill } from "../components/layout/Pill"

const Blog = ({ data: { wpPost }, pageContext }) => {
  return (
    <Layout>
      <Seo
        title={wpPost.title}
        description={striptags(wpPost.excerpt)}
        image={
          wpPost.featuredImage?.node?.localFile?.childImageSharp
            ?.gatsbyImageData
        }
      />
      <Hero
        title={wpPost.title}
        label={
          <BreadCrumb
            links={[
              { uri: "/", title: "hem" },
              { uri: "/senaste-nytt", title: "senaste nytt" },
              {
                title: truncate(wpPost.title, 10),
              },
            ]}
          />
        }
        date={dateFromWp(wpPost.date)}
        smallTitle
      ></Hero>

      <Container className="mb-12" text>
        <div dangerouslySetInnerHTML={{ __html: wpPost.content }} />
      </Container>
      <section>
        <Container className="mb-24" text>
          <Label text="Läs mer" />

          <div className="flex flex-row  sm:justify-between space-x-4 max-w-lg mx-auto  ">
            <div className=" w-1/2 px-2 py-4 bg-gray-50 rounded-xl hover:bg-cyan-100">
              {pageContext.previous ? (
                <Link
                  to={pageContext.previous.uri}
                  className="flex items-start space-x-4 text-sm uppercase w-full"
                >
                  <div className="sm:pr-2 text-3xl">‹</div>
                  <div className="flex flex-col w-full">
                    <div className="text-left  text-xs font-medium mb-2">
                      Nyare
                    </div>
                    <div className="text-left block text-xs">
                      {pageContext.previous.title}
                    </div>
                  </div>
                </Link>
              ) : (
                <> </>
              )}
            </div>
            <div className="w-1/2  px-2 py-4 bg-gray-50 rounded-xl hover:bg-cyan-100">
              {pageContext.next && (
                <Link
                  to={pageContext.next.uri}
                  className="flex items-start justify-end space-x-4 text-sm uppercase w-full"
                >
                  <div className="flex flex-col w-full">
                    <div className="text-right text-xs font-medium mb-2">
                      Äldre
                    </div>
                    <div className="text-right block text-xs">
                      {pageContext.next.title}
                    </div>
                  </div>
                  <div className="sm:pl-2  text-3xl">›</div>
                </Link>
              )}
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export default Blog

export const query = graphql`
  query BlogPostQuery($id: String) {
    wpPost(id: { eq: $id }) {
      id
      content
      title
      date(formatString: "YYYY-MM-DD")
      excerpt
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1200, layout: FIXED)
            }
          }
        }
      }
    }
  }
`
